import { useEffect, useRef, useCallback } from 'react';

export default function CustomCursor() {
  const cursorRef = useRef<HTMLDivElement>(null);
  const dotRef = useRef<HTMLDivElement>(null);
  const rafRef = useRef<number>(0);
  const mouseRef = useRef({ x: -100, y: -100 });
  const cursorPosRef = useRef({ x: -100, y: -100 });

  const animate = useCallback(() => {
    const cursor = cursorRef.current;
    const dot = dotRef.current;
    if (!cursor || !dot) return;

    cursorPosRef.current.x += (mouseRef.current.x - cursorPosRef.current.x) * 0.12;
    cursorPosRef.current.y += (mouseRef.current.y - cursorPosRef.current.y) * 0.12;

    cursor.style.transform = `translate3d(${cursorPosRef.current.x - 10}px, ${cursorPosRef.current.y - 10}px, 0)`;
    dot.style.transform = `translate3d(${mouseRef.current.x - 2}px, ${mouseRef.current.y - 2}px, 0)`;

    rafRef.current = requestAnimationFrame(animate);
  }, []);

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      mouseRef.current.x = e.clientX;
      mouseRef.current.y = e.clientY;
    };

    const handleMouseEnterLink = () => {
      cursorRef.current?.classList.add('hover');
    };

    const handleMouseLeaveLink = () => {
      cursorRef.current?.classList.remove('hover');
    };

    document.addEventListener('mousemove', handleMouseMove, { passive: true });
    rafRef.current = requestAnimationFrame(animate);

    const clickables = document.querySelectorAll('a, button, [role="button"], input, textarea, select, [data-cursor-hover]');
    clickables.forEach(el => {
      el.addEventListener('mouseenter', handleMouseEnterLink);
      el.addEventListener('mouseleave', handleMouseLeaveLink);
    });

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      cancelAnimationFrame(rafRef.current);
      clickables.forEach(el => {
        el.removeEventListener('mouseenter', handleMouseEnterLink);
        el.removeEventListener('mouseleave', handleMouseLeaveLink);
      });
    };
  }, [animate]);

  return (
    <>
      <div ref={cursorRef} className="custom-cursor max-md:hidden" />
      <div ref={dotRef} className="custom-cursor-dot max-md:hidden" />
    </>
  );
}